export default __webpack_public_path__ + "static/media/average-waiver-flyer-march-2025.fe09a582.pdf";